module.exports = __webpack_public_path__ + "img/syukyaku-landing-pa004.a7f48ae2.png";